import React, {
  ChangeEventHandler,
  FormEventHandler,
  FocusEventHandler,
  Fragment,
} from 'react';
import { Dispatch } from 'redux';
import {
  getOnChange,
  isNameChangedToggle,
  trimOnBlur,
} from '../../../helpers/handlers';
import { connect } from 'dva';

import NameChangeRadio from '../../shared/NameChangeRadio/NameChangeRadio';
import ChangeFIO from '../../shared/ChangeFIO/ChangeFIO';
import { ApplicantFields } from '../../../models/applicant';
import {
  getApplicant,
  getApplicantIsAddressCompleted,
  getApplicantMaritalStatus,
} from '../../../selectors/applicant';
import { createSelector } from 'reselect';
import { APPLICANT } from '../../../constants/modelNames';

interface StateProps {
  applicant: ApplicantFields;
  hidden: boolean;
}

interface DispatchProps {
  onChange: ChangeEventHandler;
  onBlur: FocusEventHandler;
  isNameChangedToggle: FormEventHandler;
}

type Props = StateProps & DispatchProps;

function ApplicantNameChange({
  applicant,
  onChange,
  onBlur,
  isNameChangedToggle,
  hidden,
}: Props): JSX.Element | null {
  const { changeName, ...ChangeFIOFields } = applicant;
  if (hidden) return null;

  return (
    <Fragment>
      <NameChangeRadio
        model={APPLICANT}
        changeName={changeName}
        isNameChangedToggle={isNameChangedToggle}
      />
      <ChangeFIO
        changeName={changeName}
        onChange={onChange}
        onBlur={onBlur}
        {...ChangeFIOFields}
      />
    </Fragment>
  );
}

const mapStateToProps: (state: {
  applicant: ApplicantFields;
}) => StateProps = createSelector(
  getApplicant,
  getApplicantMaritalStatus,
  getApplicantIsAddressCompleted,
  (applicant, applicantRelationsCompleted, isAddressCompleted) => ({
    applicant,
    hidden: !(isAddressCompleted && applicantRelationsCompleted),
  })
);

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(APPLICANT, dispatch),
  onBlur: trimOnBlur(APPLICANT, dispatch),
  isNameChangedToggle: isNameChangedToggle(APPLICANT, dispatch),
});

const ApplicantNameChangeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicantNameChange);

export { ApplicantNameChangeContainer as ApplicantNameChange };
